import React, { useState } from 'react';
import { LegalModal } from './ui/LegalModal';
export function Footer() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-8 bg-white border-t border-stone-100 text-center text-stone-400 text-sm" data-id="element-87">
        <p className="mb-3" data-id="element-88">
          &copy; {new Date().getFullYear()} Calentadores Vintage. Todos los
          derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-2 text-xs" data-id="element-89">
          <button onClick={() => setModal('privacy')} className="text-stone-400 hover:text-stone-900 underline underline-offset-2 transition-colors duration-200" data-id="element-90">
            Política de Privacidad
          </button>
          <span className="text-stone-300" data-id="element-91">·</span>
          <button onClick={() => setModal('terms')} className="text-stone-400 hover:text-stone-900 underline underline-offset-2 transition-colors duration-200" data-id="element-92">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={modal === 'privacy'} onClose={() => setModal(null)} title="Política de Privacidad" data-id="element-93">
        <p className="text-stone-500 text-xs uppercase tracking-widest font-medium" data-id="element-94">
          Última actualización: {new Date().getFullYear()}
        </p>

        <section data-id="element-95">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-96">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-97">
            Al realizar una compra en nuestra tienda, recopilamos información
            necesaria para procesar tu pedido, incluyendo nombre, dirección de
            envío y datos de pago. Esta información es utilizada exclusivamente
            para completar tu transacción.
          </p>
        </section>

        <section data-id="element-98">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-99">
            2. Uso de la Información
          </h3>
          <p data-id="element-100">
            La información recopilada se utiliza para: procesar y enviar tu
            pedido, comunicarte el estado de tu compra, mejorar nuestros
            productos y servicios, y cumplir con obligaciones legales
            aplicables.
          </p>
        </section>

        <section data-id="element-101">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-102">
            3. Protección de Datos
          </h3>
          <p data-id="element-103">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o divulgación. Los datos de pago son procesados mediante
            plataformas seguras y certificadas.
          </p>
        </section>

        <section data-id="element-104">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-105">
            4. Cookies
          </h3>
          <p data-id="element-106">
            Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
            navegación. Puedes configurar tu navegador para rechazar cookies,
            aunque esto podría afectar algunas funcionalidades del sitio.
          </p>
        </section>

        <section data-id="element-107">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-108">
            5. Terceros
          </h3>
          <p data-id="element-109">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros, excepto cuando sea necesario para completar tu pedido
            (por ejemplo, servicios de mensajería y paquetería).
          </p>
        </section>

        <section data-id="element-110">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-111">
            6. Tus Derechos
          </h3>
          <p data-id="element-112">
            Tienes derecho a acceder, corregir o solicitar la eliminación de tu
            información personal en cualquier momento. Para ejercer estos
            derechos, puedes comunicarte con nosotros a través de nuestros
            canales oficiales.
          </p>
        </section>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={modal === 'terms'} onClose={() => setModal(null)} title="Términos y Condiciones" data-id="element-113">
        <p className="text-stone-500 text-xs uppercase tracking-widest font-medium" data-id="element-114">
          Última actualización: {new Date().getFullYear()}
        </p>

        <section data-id="element-115">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-116">
            1. Aceptación de Términos
          </h3>
          <p data-id="element-117">
            Al realizar una compra en nuestra tienda, aceptas los presentes
            Términos y Condiciones en su totalidad. Si no estás de acuerdo con
            alguno de estos términos, te pedimos que no realices ninguna compra.
          </p>
        </section>

        <section data-id="element-118">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-119">
            2. Descripción del Producto
          </h3>
          <p data-id="element-120">
            Los Calentadores Vintage de Piel Sintética son accesorios de moda
            fabricados con fibra sintética de alta calidad. Las imágenes del
            producto son representativas; los colores pueden variar ligeramente
            según la pantalla de tu dispositivo. El producto no contiene
            materiales de origen animal.
          </p>
        </section>

        <section data-id="element-121">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-122">
            3. Precios y Pagos
          </h3>
          <p data-id="element-123">
            El precio de venta es de $31.95 USD por par. Los precios están
            sujetos a cambios sin previo aviso. El pago debe realizarse en su
            totalidad al momento de la compra a través de los métodos de pago
            disponibles en nuestra plataforma.
          </p>
        </section>

        <section data-id="element-124">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-125">
            4. Envíos
          </h3>
          <p data-id="element-126">
            Realizamos envíos a todo México. Los tiempos de entrega estimados
            son de 5 a 10 días hábiles dependiendo de tu ubicación. El envío es
            seguro y con número de rastreo. No nos hacemos responsables por
            retrasos causados por la paquetería o situaciones de fuerza mayor.
          </p>
        </section>

        <section data-id="element-127">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-128">
            5. Devoluciones y Cambios
          </h3>
          <p data-id="element-129">
            Aceptamos devoluciones dentro de los 7 días naturales posteriores a
            la recepción del producto, siempre que este se encuentre en su
            estado original, sin uso y con su empaque. Los gastos de envío por
            devolución corren a cargo del cliente, salvo en casos de producto
            defectuoso.
          </p>
        </section>

        <section data-id="element-130">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-131">
            6. Limitación de Responsabilidad
          </h3>
          <p data-id="element-132">
            Calentadores Vintage no se hace responsable por el uso inadecuado
            del producto, ni por daños indirectos derivados de su uso. Nuestra
            responsabilidad máxima se limita al valor del producto adquirido.
          </p>
        </section>

        <section data-id="element-133">
          <h3 className="font-serif text-lg font-bold text-stone-900 mb-2" data-id="element-134">
            7. Modificaciones
          </h3>
          <p data-id="element-135">
            Nos reservamos el derecho de modificar estos Términos y Condiciones
            en cualquier momento. Las modificaciones entrarán en vigor desde su
            publicación en el sitio. Es responsabilidad del usuario revisar
            periódicamente estos términos.
          </p>
        </section>
      </LegalModal>
    </>;
}